console.log(String.fromCodePoint(0x1F525) + String.fromCodePoint(0x1F680));

/* Stylesheets */
import './scss/vendors/bootstrap.scss'; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
// import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
import './scss/vendors/hamburgers.scss'; // ref: https://jonsuh.com/hamburgers/#sass
import './scss/fonts.scss';
// import './scss/vendors/energy-saver.scss';
import './scss/style.scss';

/* Scripts */
import { Offcanvas } from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.

// import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
// import { } from 'swiper/modules';

import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { fab } from '@fortawesome/free-brands-svg-icons';
// import { fas } from '@fortawesome/pro-solid-svg-icons';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
// import { fal } from '@fortawesome/pro-light-svg-icons';
// import { fat } from '@fortawesome/pro-thin-svg-icons';
// import { fad } from '@fortawesome/pro-duotone-svg-icons';
// import { fass } from '@fortawesome/sharp-solid-svg-icons';
// import { fasr } from '@fortawesome/sharp-regular-svg-icons';
// import { fasl } from '@fortawesome/sharp-light-svg-icons';
// import { fast } from '@fortawesome/sharp-thin-svg-icons';
// library.add(fab, fas, far, fal, fat, fad, fass, fasr, fasl, fast);
library.add(faCircleExclamation);
dom.i2svg();

// import EnergySaver from './js/vendors/energy-saver';

import Cleave from 'cleave.js'
//require('cleave.js/dist/addons/cleave-phone.it');

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

const isDebug = process.env.NODE_ENV !== 'production';

/* Variables and functions */
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

const initMenu = () => {
    const menu = document.querySelector('#headerNav');
    if (!menu) return;

    const links = [...menu.querySelectorAll('a[href^="#"]')];
    links.forEach(link => {
        link.addEventListener('click', ev => {
            Offcanvas.getOrCreateInstance('#offcanvasNavbar').hide();
        });
    });
};

const goToAnchor = (el, offset = 0, behavior = 'smooth') => {
    if (typeof el === 'string') {
        el = document.querySelector(el);
    }

    if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({
            top: y,
            behavior: behavior
        })
    }
}

const showLoading = (el) => {
    if (!el)
        return;

    el?.classList.add('disabled');

    const loadingLayer = document.querySelector('.loading_layer');
    if (loadingLayer) {
        loadingLayer.style.display = 'block';
    }
};

const hideLoading = () => {

    const loadingButtons = [...document.querySelectorAll('.btn-loading')]
    loadingButtons.forEach(button => {
        button.classList.remove('disabled')
    })

    const loadingLayer = document.querySelector('.loading_layer')
    if (loadingLayer) {
        loadingLayer.style.display = 'none'
    }
};

const observeStickyHeader = () => {
    const sentinel = document.querySelector('.sticky-sentinel');
    const header = document.querySelector('.header');

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
                header.classList.add('is-sticky');
            } else {
                header.classList.remove('is-sticky');
            }
        },
        {
            root: null,
            threshold: 0,
            rootMargin: '12px 0px 0px 0px'
        }
    );

    observer.observe(sentinel);
}

const DoPageClientValidate = (validationGroupName) => {
    const form = document.querySelector('.form');
    const firstInvalid = form?.querySelector(":invalid");
    
    if (firstInvalid) {
        if (firstInvalid.id === "txtNomeFile1") {
            goToAnchor("#caricaButtons", 100);
        } else {
            goToAnchor(firstInvalid, 100);
        }
    }
    var result = Page_ClientValidate(validationGroupName);
    Page_BlockSubmit = false;
    return result;
};

const initCleave = () => {
    const cap = document.getElementById('txtCap');
    if (cap) {
        new Cleave(cap, {
            blocks: [5],
            numericOnly: true
        });
    }

    const datascontrino = document.getElementById('txtDataScontrino');
    if (datascontrino) {
        new Cleave(datascontrino, {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y']
        });
    }

    const orarioscontrino = document.getElementById('txtOraScontrino');
    if (orarioscontrino) {
        new Cleave(orarioscontrino, {
            time: true,
            delimiter: ':',
            timePattern: ['h', 'm']
        });
    }

    const importoscontrino = document.getElementById('txtImportoScontrino');
    if (importoscontrino) {
        new Cleave(importoscontrino, {
            blocks: [6],
            numeral: true,
            delimiter: '',
            numeralDecimalScale: 2,
            numeralDecimalMark: ',',
        });
    }

    const importoprimoprodottoscontrino = document.getElementById('txtImportoPrimoProdottoScontrino');
    if (importoprimoprodottoscontrino) {
        new Cleave(importoprimoprodottoscontrino, {
            blocks: [6],
            numeral: true,
            delimiter: '',
            numeralDecimalScale: 2,
            numeralDecimalMark: ',',
        });
    }
};

// Data layer push 
const dataLayerPush = (dataToPush) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataToPush);
}

/* Ready callback function */
ready(() => {
    initWebpackVersion();
    initMenu();
    observeStickyHeader();
    initCleave();
});

window.goToAnchor = goToAnchor;
window.showLoading = showLoading;
window.hideLoading = hideLoading;
window.DoPageClientValidate = DoPageClientValidate;
window.dataLayerPush = dataLayerPush;